import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Loader } from "../Components/Loader";

// ── Foundation pages (product features pruned) ──────────────────────────
import CreateCustomer from "../Pages/Customer/Create";
import ListCustomer from "../Pages/Customer/List";
// Note: Customer/Edit is a Dialog component (needs props), not a routable
// page — editing happens inline from the list, so it is not routed here.

import CreateCompany from "../Pages/CompanyInfo/Create";
import ListCompany from "../Pages/CompanyInfo/List";

import PrivilegeList from "../Pages/Settings/Privileges";
import UserRoleList from "../Pages/Settings/UserRoles";
import UserList from "../Pages/Settings/Users";
import EmailTemplatesPage from "../Pages/Settings/EmailTemplates";
import TemplateVariablesPage from "../Pages/Settings/Variables";

// ── Leads / CRM (leads-crm-module) ──────────────────────────────────────
import {
  LeadInquiries,
  LeadPipeline,
  LeadCalendar,
  LeadDashboard,
} from "../Pages/LeadSystem";
import LeadDetailPage from "../Pages/LeadSystem/LeadDetailPage";
import MyTasks from "../Pages/Tasks/MyTasks";
import {
  EmailInbox,
  EmailPipeline,
  EmailHubDashboard,
  EmailHubSettings,
} from "../Pages/EmailHub";

/**
 * AppRoutes — slim foundation router. Only the pages that still exist in
 * this starter are routed. Product-specific routes were removed.
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Suspense fallback={<Loader />}>
            <Navigate to="/customer/list" replace />
          </Suspense>
        }
      />

      {/* Clients */}
      <Route
        path="/customer/list"
        element={<Suspense fallback={<Loader />}><ListCustomer /></Suspense>}
      />
      <Route
        path="/customer/create"
        element={<Suspense fallback={<Loader />}><CreateCustomer /></Suspense>}
      />

      {/* Company */}
      <Route
        path="/company/list"
        element={<Suspense fallback={<Loader />}><ListCompany /></Suspense>}
      />
      <Route
        path="/company/create"
        element={<Suspense fallback={<Loader />}><CreateCompany /></Suspense>}
      />

      {/* Leads / CRM */}
      <Route path="/leads/dashboard" element={<Suspense fallback={<Loader />}><LeadDashboard /></Suspense>} />
      <Route path="/leads/inquiries" element={<Suspense fallback={<Loader />}><LeadInquiries /></Suspense>} />
      <Route path="/leads/pipeline"  element={<Suspense fallback={<Loader />}><LeadPipeline /></Suspense>} />
      <Route path="/leads/calendar"  element={<Suspense fallback={<Loader />}><LeadCalendar /></Suspense>} />
      {/* Detail route MUST come after the static /leads/* routes */}
      <Route path="/leads/:id"       element={<Suspense fallback={<Loader />}><LeadDetailPage /></Suspense>} />

      {/* Tasks */}
      <Route path="/tasks" element={<Suspense fallback={<Loader />}><MyTasks /></Suspense>} />

      {/* Email Hub */}
      <Route path="/email-hub/inbox"     element={<Suspense fallback={<Loader />}><EmailInbox /></Suspense>} />
      <Route path="/email-hub/pipeline"  element={<Suspense fallback={<Loader />}><EmailPipeline /></Suspense>} />
      <Route path="/email-hub/dashboard" element={<Suspense fallback={<Loader />}><EmailHubDashboard /></Suspense>} />
      <Route path="/email-hub/settings"  element={<Suspense fallback={<Loader />}><EmailHubSettings /></Suspense>} />

      {/* Settings — RBAC + templates */}
      <Route path="/settings/users" element={<Suspense fallback={<Loader />}><UserList /></Suspense>} />
      <Route path="/settings/roles" element={<Suspense fallback={<Loader />}><UserRoleList /></Suspense>} />
      <Route path="/settings/privileges" element={<Suspense fallback={<Loader />}><PrivilegeList /></Suspense>} />
      <Route path="/settings/email-templates" element={<Suspense fallback={<Loader />}><EmailTemplatesPage /></Suspense>} />
      <Route path="/settings/variables" element={<Suspense fallback={<Loader />}><TemplateVariablesPage /></Suspense>} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/customer/list" replace />} />
    </Routes>
  );
};

export default AppRoutes;
